import { FC } from "react";

type DetailsPageLoadingStateContainerProps = {
  showPlaceholder: boolean;
};

const DetailsPagePlaceholderContainer: FC<
  DetailsPageLoadingStateContainerProps
> = ({ showPlaceholder = true, children }) => (
  <div className={`details-page-placeholder-${showPlaceholder ? "on" : "off"}`}>
    {children}
  </div>
);

export default DetailsPagePlaceholderContainer;
